import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=1895c8c6&"
import script from "./IconRight.vue?vue&type=script&lang=js&"
export * from "./IconRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1895c8c6')) {
      api.createRecord('1895c8c6', component.options)
    } else {
      api.reload('1895c8c6', component.options)
    }
    module.hot.accept("./IconRight.vue?vue&type=template&id=1895c8c6&", function () {
      api.rerender('1895c8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRight.vue"
export default component.exports